const ENCODED_EMPTY_EXPERIENCE = 'W10=';

const DEV_EXPERIENCES = [
  {
    impressionId: null,
    experienceName: 'VM | AB-4742 | Update Review Page for Better Booking Completion',
    variantLabel: 'B-Variant',
    parameters: {
      reviewPageChange: 'true',
    },
  },
];

const MONETATE_EVENT_NAMES = {
  REVIEW_PAGE_CONFIRM_BOOKING: 'click_confirmBooking_in_appointment_review',
  ABOUT_YOU_USER_DETAILS: 'click_about_you_user_details',
};

const MONETATE_EVENTS_STRING = {
  NEW_CONFIRM_BOOKING_EXP: 'AB-4742',
};

export { DEV_EXPERIENCES, ENCODED_EMPTY_EXPERIENCE, MONETATE_EVENT_NAMES, MONETATE_EVENTS_STRING };
